module.exports = __webpack_public_path__ + "static/media/RG_35.fadbc70c.png";